import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";
import { LOGISTIC_REQUEST_SERVICE } from "../EndPoints";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllLogisticRequestById = createAsyncThunk(
    'logisticRequestSection/getAllLogisticRequestById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${LOGISTIC_REQUEST_SERVICE.getAllLogisticRequestById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetAllLogisticRequest = createAsyncThunk(
    'logisticRequestSection/getAllLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(LOGISTIC_REQUEST_SERVICE.getAllLogisticRequest, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const CreateLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/createLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(LOGISTIC_REQUEST_SERVICE.createLogisticRequest, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const UpdateLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/updateLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.updateLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const DeleteLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/deleteLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`${LOGISTIC_REQUEST_SERVICE.deleteLogisticRequest}${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AssignLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/assignLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.assignLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AcceptLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/acceptLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.acceptLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const RejectLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/rejectLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.rejectLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const PreInTransitIssueLogisticRequest = createAsyncThunk(
    'logisticRequestSection/preInTransitIssueLogisticRequest',
    async (payload, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.preInTransitIssueLogisticRequest, payload)
            .then((response) => response)
            .catch((error) => error.response);

        const { data, status } = result;
        return { data, status };
    },
);

export const InTransitLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/inTransitLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.inTransitLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const InTransitIssueLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/inTransitIssueLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.inTransitIssueLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const DeliverLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/deliverLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.deliverLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const CancelLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/cancelLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.cancelLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AddEmployeesVehiclesLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/addEmployeesVehiclesLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOGISTIC_REQUEST_SERVICE.addEmployeesVehiclesLogisticRequest,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

